import './UploadFileDefaultText.scss';

interface IUploadFileDefaultTextProps {
  acceptedFormats: string[];
  maxFileSize: number;
}

const UploadFileDefaultText = ({ acceptedFormats, maxFileSize }: IUploadFileDefaultTextProps) => {
  return (
    <div className="uploadFileDefaultText">
      <p className="uploadFileDefaultTextTitle">
        <span className="underline">Subir</span> o arrastrar la plantilla actualizada
      </p>
      <p className="uploadFileDefaultTextDescription">
        <span>Formatos aceptados: {acceptedFormats.join(', ')}</span> &nbsp;
        <span>Peso máximo: {maxFileSize} MB</span>
      </p>
    </div>
  );
};

export default UploadFileDefaultText;
